import { FormsModule } from '@angular/forms';
import { RegistrationWorkflow } from '../../application/registration-workflow.service';
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { TranslatePipe } from '@ngx-translate/core';

import { MemberStateService } from '../../application/member-state.service';
import { RegistrationTracking } from '../../integrations/registration-tracking.service';
import { SfappService } from '../../../../core/services/sfapp.service';
import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'app-step4',
    imports: [TranslatePipe, FormsModule],
    templateUrl: './step4.component.html'
})
export class Step4Component implements OnInit {
  readonly workflow = inject(RegistrationWorkflow);
  outcomeChecked = false;
  private stateService = inject(MemberStateService);
  private tracking = inject(RegistrationTracking);
  private sfapp = inject(SfappService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  state = this.stateService.get();
  private sfTop = environment.sfTopUrl;
  btPostUrl = environment.btPostUrl;
  btPostValues: Array<{ key: string; value: string }> = [];
  btPostValuesAvailable = false;

  get canShowBtRegistration(): boolean {
    return this.state.showSuccess && this.btPostValuesAvailable;
  }

  async ngOnInit(): Promise<void> {
    const type = this.route.snapshot.params['type'];
    const studioId = this.route.snapshot.params['studioId'];

    const recovered = this.workflow.resume();
    if (recovered && (recovered.type !== type || String(recovered.studioId) !== studioId)) {
      await this.router.navigate(['/step4', recovered.type, recovered.studioId], { replaceUrl: true }); return;
    }
    if (this.workflow.unknown || this.workflow.message) return;
    if (!this.state.showFailed && !this.state.showSuccess) {
      if (this.stateService.restoreStep4Completion(type, studioId)) {
        this.state = this.stateService.get();
      } else {
        this.router.navigate(['/step1']);
        return;
      }
    }

    if (!this.state.showSuccess) return;
    const btValuesPromise = this.sfapp.createBtPostValues(this.state.member.id).catch(() => null);
    // Optional tracking must not hold payment continuation hostage to tag loading.
    void this.tracking.track(type, studioId);

    const values = await btValuesPromise;
    this.btPostValues = Array.isArray(values) ? values : [];
    this.btPostValuesAvailable = values !== null && values !== undefined;
  }

  acknowledgeOutcome(): void {
    if (this.outcomeChecked && this.workflow.acknowledgeUnknown()) this.router.navigate(['/step1']);
  }

  goToTop(): void {
    window.location.href = this.sfTop;
  }
}
